"use client";

import { HelpCircle, UserPlus } from "lucide-react";
import { useTranslations } from "next-intl";
import { AppButton } from "@/components/design/forms";

export interface RegistrationFlowHeroProps {
    participantCount: number;
    onOpenInfo: () => void;
}

export function RegistrationFlowHero({
    participantCount,
    onOpenInfo,
}: RegistrationFlowHeroProps) {
    const t = useTranslations("strings.registrationFlow");

    return (
        <div className="mb-12 max-w-full min-w-0 text-center">
            <div className="mb-6 inline-flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-fest-gold to-fest-gold-mid shadow-2xl shadow-fest-gold/30">
                <UserPlus className="h-10 w-10 text-white" />
            </div>
            <h1
                className="mb-4 break-words text-3xl font-bold text-fest-heading sm:text-4xl md:text-5xl lg:text-6xl"
                style={{ fontFamily: "Playfair Display, serif" }}
            >
                {t("pageTitle")}
            </h1>
            <p className="mx-auto max-w-2xl px-1 text-base text-fest-subtle-text sm:text-lg md:text-xl">
                {t("pageSubtitle")}
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
                <div className="inline-flex items-center gap-2 rounded-full border border-fest-border-warm bg-white px-4 py-2 shadow-sm">
                    <span className="text-sm font-medium text-fest-heading">
                        {participantCount}{" "}
                        {t("participantWord", { count: participantCount })}
                    </span>
                </div>
                <AppButton
                    onClick={onOpenInfo}
                    className="inline-flex items-center gap-2 rounded-full border-2 border-fest-gold bg-white px-4 py-2 text-fest-gold transition-all hover:bg-fest-gold hover:text-white"
                >
                    <HelpCircle className="h-4 w-4" />
                    <span className="text-sm font-medium">{t("howItWorks")}</span>
                </AppButton>
            </div>
        </div>
    );
}
